module.exports = __webpack_public_path__ + "10ce684e0c09e50b34aba112a82338f7.pdf";